<template>
	<div class="shareholders" ref="slideContainer">
		<Title :zhTitle="pageData.name" :enTitle="pageData.name"></Title>
		<div class="quantity" v-if="pageData.sseTotal !== ''">
			<span v-if="language === 'zh'">股东户数：{{ pageData.sseTotal }}名</span>
			<span v-else-if="language === 'en'">Number of Shareholders：{{ pageData.sseTotal }}</span>
		</div>
		<div class="describe">
			<span v-if="language === 'zh'">
        <span v-if="periodName === '一季度' || periodName === '前三季度'">{{ jsonData.year}}{{ periodName }}前10名股东持股情况</span>
        <span v-else>{{ jsonData.year }}{{ periodName }}前10名股东持股情况及报告期内增减</span>
      </span>
			<span v-else-if="language === 'en'">
        <span v-if="periodNameEng === 'Q1' || periodNameEng === 'Q1-Q3'" >Shareholdings of the top 10 shareholders in {{ jsonData.year }}{{ periodNameEng }}</span>
        <span v-else>Shareholdings of the top 10 shareholders in {{ jsonData.year }}{{ periodNameEng }} and Changes in the Reporting Period</span>
      </span>
		</div>
		<div class="content">
			<div class="table">
				<div class="table-row">
					<div class="table-cell column1"></div>
					<div class="table-cell column2"></div>
					<div class="table-cell column3-th"><span v-if="language === 'zh'">持股</span><span v-else-if="language === 'en'">Shareholding</span></div>
					<div class="table-cell column4-th" v-if="jsonData.period === 'year' || jsonData.period === 'half'"><span v-if="language === 'zh'">报告期内增减</span><span v-else-if="language === 'en'">Changes</span></div>
				</div>
				<div class="table-row" v-for="(row, index) in pageData.shareholders" :key="index">
					<div class="table-cell column1">
						<span v-if="index < 9">0{{ index + 1 }}</span
						><span v-else>{{ index + 1 }}</span
						>.
						<span v-if="language === 'zh'">
							<span v-if="row.shholdername" :title="row.shholdername">{{ row.shholdername }}</span>
							<span v-else>&nbsp;</span>
						</span>
						<span v-else-if="language === 'en'">
							<span v-if="row.shholdername_eng" :title="row.shholdername_eng">{{ row.shholdername_eng }}</span>
							<span v-else-if="row.shholdername" :title="row.shholdername">{{ row.shholdername }}</span>
							<span v-else>&nbsp;</span>
						</span>
					</div>
					<div class="table-cell column2">
						<div class="progress-bar-container" v-if="row.shholdername">
							<div v-if="showBar" class="progress-bar-div" :style="{ width: row.showValue1 }">
								<div class="progress-bar"></div>
							</div>
						</div>
					</div>
					<div class="table-cell column3">
						<span v-if="row.shholdername">{{ row.showValue }}</span>
					</div>
					<div class="table-cell column4" v-if="jsonData.period === 'year' || jsonData.period === 'half'">
						<span v-if="row.shholdername">
							<span class="left-text" v-if="row.wqtb == 'new'"><img class="new" :src="newImg" /></span>
							<span class="left-text" v-else>{{ row.wqtb }}%</span>
							<img class="qs" v-if="row.wqtb * 1 > 0" :src="upImg" />
							<img class="qs" v-else-if="row.wqtb * 1 < 0" :src="downImg" />
							<img class="qs" v-else-if="row.wqtb * 1 == 0" :src="cpImg" />
							<span v-else>&nbsp;&nbsp;</span>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Title from '@/components/title.vue'
import { mapState } from 'vuex'

export default {
	name: 'shareholders',
	components: {
		Title,
	},
	props: {
		index: {
			type: Number,
		},
	},
	data() {
		return {
			pageData: {},
			newImg: '',
			upImg: '',
			downImg: '',
			cpImg: '',
			showBar: false,
		}
	},
	computed: {
		...mapState(['theme', 'language', 'jsonData', 'periodName', 'periodNameEng','isLongChart']),
	},
  watch:{
    language(newVal, oldVal) {
      let data = JSON.parse(this.jsonData.moduleData)
      if (newVal == 'zh') { // 根据语言获取相应数据
        data = JSON.parse(this.jsonData.moduleData)
      } else {
        data = JSON.parse(this.jsonData.moduleDataEng)
      }
      this.pageData = data[this.index]
      // 修改数据格式 增加百分号
      this.pageData.shareholders.forEach(item => {
        if (item.holderamt != null && item.holderamt != '') {
          item.holderamt = item.holderamt.endsWith("%") ? item.holderamt : item.holderamt + '%';
          item.showValue = item.showValue.endsWith("%") ? item.showValue : item.showValue + '%';
          item.showValue1 = item.showValue1.endsWith("%") ? item.showValue1 : item.showValue1 + '%';
        }
      })
    }
  },
	mounted() {
		let data = JSON.parse(this.jsonData.moduleData)
		if (this.language == 'zh') { // 根据语言获取相应数据
			data = JSON.parse(this.jsonData.moduleData)
		} else {
			data = JSON.parse(this.jsonData.moduleDataEng)
		}
		this.pageData = data[this.index]
    // 修改数据格式 增加百分号
    this.pageData.shareholders.forEach(item => {
      if (item.holderamt != null && item.holderamt != '') {
        item.holderamt = item.holderamt.endsWith("%") ? item.holderamt : item.holderamt + '%';
        item.showValue = item.showValue.endsWith("%") ? item.showValue : item.showValue + '%';
        item.showValue1 = item.showValue1.endsWith("%") ? item.showValue1 : item.showValue1 + '%';
      }
    })
		this.newImg = require('../assets/image/' + this.theme + '/new.png')
		this.upImg = require('../assets/image/' + this.theme + '/up.png')
		this.downImg = require('../assets/image/' + this.theme + '/down.png')
		this.cpImg = require('../assets/image/' + this.theme + '/chiping.png')
		this.initObserver()
	},
	methods: {
		initObserver() {

      if (this.isLongChart) {
        setTimeout(() => {
          this.showBar = true
        }, 200)
      } else {

        // 创建一个新的 IntersectionObserver 对象，当其监听到目标元素的可见部分（的比例）超过了一个或多个阈值（threshold）时，会执行指定的回调函数
        this.observer = new IntersectionObserver(
            entries => {
              entries.forEach(entry => {
                if (entry.isIntersecting) {
                  this.showBar = true
                  this.observer.disconnect() // 一旦元素进入视窗，就断开观察器
                }
              })
            },
            {
              threshold: this.isLongChart ? 0 : 0.1, // 当目标元素的可见比例达到10%时，触发回调
            }
        )

        this.observer.observe(this.$refs.slideContainer)
      }
		},
	},
}
</script>

<style lang="scss" scoped>
.red {
	.shareholders {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}

.purple {
	.shareholders {
		margin-top: 14px;
		width: 1040px;
		height: 503px;
		position: relative;
		background: #ffffff;
		box-shadow: 2px 2px 10px 6px rgba(211, 47, 46, 0.07);
    border: 1px solid rgba(211, 47, 46, 0.07);
	}
}
.quantity {
	position: absolute;
	top: 23px;
	right: 50px;
	padding: 0 16px;
	height: 32px;
	background: var(--baseColor);
	border-radius: 16px;
	text-align: center;
	font-size: 18px;
	font-weight: 600;
	color: #ffffff;
	line-height: 32px;
}

.describe {
	margin-left: 50px;
	margin-top: 12px;
	height: 28px;
	font-size: 20px;
	font-weight: 600;
	color: var(--timeTitleColor);
	line-height: 28px;
}

.content {
	margin-top: 8px;
	margin-left: 50px;
	width: 940px;
	height: 339px;
	border-radius: 8px;
	border: 1px solid var(--borderColor);
}

.table {
	margin: 0;
	margin: 8px 16px;
	list-style-type: none;
}
.table-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.table-cell {
	height: 30px;
	line-height: 30px;
	display: inline-block;
}

.column3-th {
	text-align: center;
	width: 75px;
	height: 20px;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 20px;
}
.column4-th {
	text-align: center;
	width: 85px;
	height: 20px;
	font-size: 14px;
	font-weight: 400;
	color: var(--timeTitleColor);
	line-height: 20px;
}

.column1 {
	width: 371px;
	font-size: 16px;
	font-weight: 400;
	color: var(--timeTitleColor);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.column2 {
	width: 301px;
	display: flex;
	align-items: center;
}
.progress-bar-container {
	width: 301px;
	height: 11px;
	border-radius: 10px;
	background: linear-gradient(to right, rgba(211, 47, 46, 0.23), rgba(211, 47, 46, 0.1));
	overflow: hidden;
}

.progress-bar {
	height: 100%;
	border-radius: inherit;
	background: linear-gradient(to right, rgba(249, 205, 112, 1), rgba(249, 205, 112, 1));
	animation: bgGradient 1s linear forwards; /* 应用动画，持续2秒，线性速度，动画结束后保持最后一帧 */
	background: linear-gradient(270deg, var(--baseColor) 0%, #feab66 100%);
}
.progress-bar-div {
	height: 100%;
	border-radius: inherit;
	background: transparent;
}
.column3 {
	text-align: right;
	width: 56px;
	height: 22px;
	font-size: 16px;
	font-weight: 600;
	color: var(--baseColor);
	line-height: 22px;
}
.column4 {
	text-align: right;
	width: 88px;
	height: 22px;
	font-size: 16px;
	font-weight: 600;
	color: var(--baseColor);
	line-height: 22px;
}

.qs {
	margin-left: 5px;
	width: 14px;
	height: 14px;
}
.new {
	margin-right: 15px;
	width: 48px;
	height: 18px;
}

.left-text {
	display: inline-block;
	width: 68px;
}

.purple {
	.quantity {
		background: #8bcaea;
	}
	.progress-bar-container {
		background: rgba(249, 205, 112, 0.2);
	}

	.progress-bar {
		background: linear-gradient(to right, rgba(249, 205, 112, 1), rgba(249, 205, 112, 1));
		animation: bgGradient 1s linear forwards; /* 应用动画，持续2秒，线性速度，动画结束后保持最后一帧 */
	}

	.column3 {
		color: #512f80;
	}
	.column4 {
		color: #512f80;
	}
}
.blue {
	.shareholders {
		padding: 0 80px;
		padding-top: 27px;
		width: 980px;
		height: 489px;
		position: relative;
	}
	.quantity {
		background: linear-gradient(90deg, #4782ea 0%, #5db6fc 100%);
		border-radius: 16px;
		font-weight: 600;
		font-size: 18px;
		color: #ffffff;
	}
	.describe {
		margin: 0;
		margin-top: 34px;
		height: 28px;
		font-size: 20px;
		font-weight: 600;
		color: var(--timeTitleColor);
		line-height: 28px;
	}

	.content {
		margin: 0;
		margin-top: 8px;
		width: 980px;
		height: 339px;
		background: #ecf2fd;
		border-radius: 8px;
		border: none;
	}
	.progress-bar-container {
		background: #e5e5e5;
	}

	.progress-bar {
		background: linear-gradient(to right, #f8bc27, #f8bc27);
		animation: bgGradient 1s linear forwards; /* 应用动画，持续2秒，线性速度，动画结束后保持最后一帧 */
		background: linear-gradient(270deg, #4782ea 0%, #5db6fc 100%);
	}
	.column3 {
		color: #3468c4;
	}
	.column4 {
		color: #3468c4;
	}
}
.yellow {
	.shareholders {
		width: 980px;
		height: 510px;
		padding: 0 80px;
		background: #f5f6f8;
		border-radius: 28px;
		position: relative;
	}
	.quantity {
		background: #f8bc27;
		border-radius: 16px;
		font-weight: 600;
		font-size: 18px;
		color: #0a0a0a;
	}
	.describe {
		margin: 0;
		margin-top: 34px;
		height: 28px;
		font-size: 20px;
		font-weight: 600;
		color: var(--timeTitleColor);
		line-height: 28px;
	}

	.content {
		margin: 0;
		margin-top: 8px;
		width: 980px;
		height: 339px;
		background: #ffffff;
		border-radius: 8px;
		border: none;
	}
	.progress-bar-container {
		background: #eaeaea;
	}

	.progress-bar {
		background: linear-gradient(to right, #f8bc27, #f8bc27);
		animation: bgGradient 1s linear forwards; /* 应用动画，持续2秒，线性速度，动画结束后保持最后一帧 */
	}
	.column3 {
		color: #eda900;
	}
	.column4 {
		color: #eda900;
	}
}
@keyframes bgGradient {
	0% {
		width: 0%;
	}
	100% {
		width: 100%;
	}
}
</style>
